import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=2ac5baa0&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Team.vue?vue&type=style&index=1&id=2ac5baa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5baa0",
  null
  
)

export default component.exports